import { FunctionComponent } from 'react'

import { Box, BoxProps } from '@theme-ui/components'

const WhiteBox: FunctionComponent<BoxProps> = ({ sx, ...rest }) => (
  <Box sx={{ bg: 'white', borderRadius: 20, p: 8, ...sx }} {...rest} />
)

export default WhiteBox
